// src/css/subscriptionPlanStyle.js

const styles = {
    container: {
        width: '100%',
        minHeight: '100vh',
        padding: 0,
    },
    headerBox: {
        width: '100%',
        height: { xs: '250px', sm: '230px', md: '200px', lg: '200px' },
        padding: 0,
        backgroundSize: 'cover',         // Cover the entire area
        backgroundPosition: 'center',     // Center the image
        backgroundRepeat: 'no-repeat',    // Do not repeat the image
        position: 'relative',
        marginTop: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: "100%",
    },
    headerTextTitle: {
        color: '#ffff',
        textAlign: 'center',
        fontFamily: 'Poppins, Arial, sans-serif',
        fontWeight: '600',
        fontSize: { xs: '25px', sm: '35px', md: '40px', lg: '45px' },
        px: 1,
        mb: 2,
    },
    headerText: {
        color: '#ffff',
        textAlign: 'center',
        fontFamily: 'Poppins, Arial, sans-serif',
        fontWeight: '600',
        fontSize: '16px',
        px: 2,
        // pb: 4,
    },
    ambdLinkText: {
        color: 'Black',
        textAlign: 'center',
        fontFamily: 'Poppins, Arial, sans-serif',
        fontWeight: '500',
        fontSize: '18px',
        pt: 3,
    },
    subscriptionBox: {
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius: '8px',
        display: 'flex', 
        flexDirection: 'column', 
        height: '100%', 
        background: 'white',
        mb: 3,
        m: 2,
    },
    boxHeader: {
        boxShadow: '2px 0px 4px 0px #00000040',
        background: '#0D8B5A',
        RadiusTopLeft: '8px',
        borderTopLeftRadius: '8px', 
        borderTopRightRadius: '8px', 
        textAlign: 'center',
    },
    boxHeaderText: {
        color: 'white',
        textAlign: 'center',
        fontFamily: 'Nunito',
        fontWeight: '700',
        fontSize: '18px',
        py: 1,
    },
    boxBodyText: {
        color: 'black',
        fontFamily: 'Nunito',
        fontWeight: '400',
        fontSize: '12px',
        pb: 2,
    },
    boxBody: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    pkgBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        border: '1px solid #0D8B5A',
        borderRadius: '6px',
        p: 1,
        mb: 2,
    },
    pkgTitle: {
        fontFamily: 'Nunito',
        fontWeight: '700',
        fontSize: '16px',
        color: '#0D8B5A'
    },
    pkgBtn: {
        background: 'linear-gradient(180deg, #12CE85 0%, #0D8B5A 80.21%)',
        boxShadow: '0px 4px 4px 0px #00000040',
        // On click
        // Navigate to: "None";
        // Animate: Instant;
        animationDuration: '0ms',
        borderRadius: '6px',
        p: 1,
        mt: 2,
        width: '60%',
    },
    pkgBtnText: {
        color: 'white',
        fontFamily: 'Nunito',
        fontWeight: '700',
        fontSize: '22px',
        textAlign: 'center',
    },
    jobNo: {
        color: '#0D8B5A',
        fontFamily: 'Nunito',
        fontWeight: '600',
        fontSize: '12px',
    }
}

export default styles;
